import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Backdrop,
  Box,
  Button,
  Grid,
  Typography,
  InputAdornment,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  Select,
  Modal,
} from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../components/AppLoader/AppLoader';
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import LockResetIcon from "@mui/icons-material/LockReset";
import Person4OutlinedIcon from "@mui/icons-material/Person4Outlined";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import SaveIcon from "@mui/icons-material/Save";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonIcon from "@mui/icons-material/Person";
import AddCardIcon from "@mui/icons-material/AddCard";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import moment from "moment/moment";
import { Snackbar, Alert } from "@mui/material";
import Error from "../../../components/error/error";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CheckPermissions from "../../../authorization/authorization";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import AdminCompanySelect from "../../../components/AdminCompanySelect/AdminCompanySelect";
import BasicTable from "../../../components/basicTable/basicTable";
import {
  fetchPaginatedUsers,
  firstPage,
  lastPage,
  nextPage,
  previousPage,
} from "../../../features/accessManagement/usersSlice";
import { AllCFCs } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import { tableStyle } from "../../../style/common";
import { AllRoles } from "../../../network/APIs/APIs";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  colors,
  allCFCLevelsAPI,
  allCompaniesAPI,
  allEmployeeRoleTypes,
  handleFileUpload,
  isImage,
  isPdf,
} from "../../../services/Functions";
import "./UserManagement.scss";
import * as Yup from "yup";
import { useFormik } from "formik";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { passwordRegex } from "../../../../src/utils/PortalName";
import ChangePasswordIcon from "../../../../src/images/reset-password.png";
import UserIconImage from "../../../images/user.jpg";
import pdfIcon from "../../../images/pdfIcon.png";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import UpdateUserPopup from "../../../components/UpdateUserPopup/updateUserPopup";
import {
  updateName,
  updatePhone,
  updateEmail,
  updateCnic,
} from "../../../features/authentication/authenticationSlice";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import {
  getInitialAdminOfficeCode,
  resolveApiOfficeCode,
} from "../../../utils/adminCompany";

/** Layout-only for modal headers; colors come from `.user-mgmt-modal-header` in UserManagement.scss. */
const USER_MGMT_PROFILE_MODAL_HEADER_SX = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
};

const USER_MGMT_PROFILE_MODAL_TITLE_SX = {
  fontWeight: 700,
  lineHeight: 1.2,
};

/** SAVE / SUBMIT — profile / edit / change-password modals */
const USER_MGMT_MODAL_PRIMARY_BUTTON_SX = {
  px: 3.5,
  py: 1,
  borderRadius: 1.5,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "none",
  color: "#fff",
  bgcolor: "#003971",
  "&:hover": { bgcolor: "#002a56" },
  "&.Mui-disabled": {
    bgcolor: "rgba(0, 57, 113, 0.42)",
    color: "rgba(255, 255, 255, 0.9)",
  },
  boxShadow: "0 2px 8px rgba(0, 57, 113, 0.35)",
};

export default function UserManagementTable(props) {
  //#region
  const [newusersToDataGrid, setNewUsersToDataGrid] = useState([]);
  const dispatch = useDispatch();
  const [openTransferPopup, setOpenTransferPopup] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);

  const [open, setOpen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [dltuser, setdltuser] = useState();
  const Navigate = useNavigate();
  // Add these near your other dialog states
  const [openTransferSuccessModal, setOpenTransferSuccessModal] =
    useState(false);
  const [transferSuccessMessage, setTransferSuccessMessage] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const {
    token,
    permissions,
    code: officeCode,
    hierarchy,
    userId: loggedInUserId,
    roleId,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);

  const isAdminUser = String(officeCode) === "10";
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(() =>
    getInitialAdminOfficeCode(officeCode, selectedAdminCompanyCode),
  );

  const usersListOfficeCode = useMemo(
    () =>
      resolveApiOfficeCode(
        officeCode,
        roleId,
        selectedCompanyCode,
        selectedAdminCompanyCode,
      ),
    [officeCode, roleId, selectedCompanyCode, selectedAdminCompanyCode],
  );

  const syncAuthIfEditingSelf = (editedUserId, action) => {
    if (
      editedUserId != null &&
      loggedInUserId != null &&
      String(editedUserId) === String(loggedInUserId)
    ) {
      dispatch(action);
    }
  };
  let userCompany = officeCode.slice(0, 2);
  // const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || [],
  );
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openProfileModalName, setOpenProfileModalName] = useState(false);
  const [openProfileModalPhoneNo, setOpenProfileModalPhoneNo] = useState(false);
  const [openProfileModalEmail, setOpenProfileModalEmail] = useState(false);
  const [openProfileModalCNIC, setOpenProfileModalCNIC] = useState(false);
  const [openProfileModalTransferPosting, setOpenProfileModalTransferPosting] =
    useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [noDataFound, setNoDataFound] = useState(false);
  const {
    pageNumber,
    pageSize,
    data: users,
    totalPages,
    totalRecords,
    pageNumber: currentPage,
    isLoading: isLoad,
  } = useSelector((state) => state.users);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);
  const [apiError, setApiError] = useState("");
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [editableFields, setEditableFields] = useState({
    name: false,
    phoneNo: false,
    CNIC: false,
    email: false,
  });
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [hierarchyList, setHierarchyList] = useState([]);
  const [cfcsList, setcfcsList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subdivisionList, setsubDivisionList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [supportCenterName, setSupportCenterName] = useState("-");
  const [isLoadingCfcName, setIsLoadingCfcName] = useState(false);
  const [profileImageSrc, setProfileImageSrc] = useState(UserIconImage);
  const [technicalLevels, setTechnicalLevels] = useState([
    {
      value: 1,
      label: "PITC",
    },
    {
      value: 2,
      label: "DISCO",
    },
    {
      value: 3,
      label: "Circle",
    },
    {
      value: 4,
      label: "Division",
    },
    {
      value: 52,
      label: "Sub Division",
    },
  ]);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [allRoles, setAllRoles] = useState();
  const [propertyDocuments, setPropertDocuments] = useState("");
  const [propertyDocumentError, setPropertyDocumentError] = useState("");
  const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] =
    useState("");
  const errorCloses = () => {
    setApiError("");
  };
  const handleCloseName = () => {
    setOpenProfileModalName(false);
    nameFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleClosePhoneNo = () => {
    setOpenProfileModalPhoneNo(false);
    phoneNoFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleCloseEmail = () => {
    setOpenProfileModalEmail(false);
    gmailFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleCloseCNIC = () => {
    setOpenProfileModalCNIC(false);
    cnicFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };

  // const handleCloseTransferPosting = () => {
  //     setOpenProfileModalTransferPosting(false);
  //     transferPostingFormik.resetForm();   // reset form values to initial
  //     setSelectedUser(null);    // clear selected user
  //     setPropertDocuments("");
  //     setPropertyDocumentsThumbnail("");
  //     setPropertyDocumentError("");
  //     setApiError("");
  // };
  //#endregion
  const toggleEdit = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  useEffect(() => {
    if (users) {
      apiToDataGridConversion();
    }
  }, [users]);
  const initialValues = {
    iv_new_password: "",
    iv_confirm_password: "",
    iv_remarks: "",
    iv_full_name: "",
    iv_full_name_remarks: "",
  };
  const passwordChangeFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_new_password: Yup.string()
        .required("Password is required")
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        ),
      iv_confirm_password: Yup.string()
        .required("Confirm password is required")
        .oneOf(
          [Yup.ref("iv_new_password")],
          "Password and Confirm password must match",
        ),
      iv_remarks: Yup.string()
        .max(100, "Remarks can be max 100 characters long.")
        .required("Remarks are required."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: selectedUserId,
        password: values.iv_new_password,
        remarks: values.iv_remarks,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            setShowChangePasswordPopup(false);
            setShowSuccessSnackbar(true);
            setTimeout(() => {
              setShowChangePasswordPopup(false);
            }, 300);
          } else if (result.status === "400") {
            setApiError(result.message);
          }
        })
        .catch(() => {});
      setViewBackdrop(false);
    },
  });

  const handleCloseChangePasswordDialog = () => {
    setShowChangePasswordPopup(false);
    setSelectedUserId(null);
    passwordChangeFormik.resetForm();
  };

  const nameFormik = useFormik({
    initialValues: {
      iv_full_name: "",
      iv_full_name_remarks: "",
    },
    validationSchema: Yup.object({
      iv_full_name: Yup.string()
        .min(3, "Name should be at least 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Enter name."),
      iv_full_name_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          name: values.iv_full_name,
          remarks: values.iv_full_name_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeNameofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          syncAuthIfEditingSelf(selectedUser.userId, updateName(values.iv_full_name));
          setOpenProfileModalName(false);
          nameFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "Name updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            name: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const phoneNoFormik = useFormik({
    initialValues: {
      iv_phone_no: "",
      iv_phone_no_remarks: "",
    },
    validationSchema: Yup.object({
      iv_phone_no: Yup.string()
        .required("Please enter valid mobile number.")
        .matches(/^03\d{9}$/, "Enter phone number as 03001234567"),
      iv_phone_no_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          phoneNo: values.iv_phone_no,
          remarks: values.iv_phone_no_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changePhoneNoofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          syncAuthIfEditingSelf(
            selectedUser.userId,
            updatePhone(values.iv_phone_no),
          );
          setOpenProfileModalPhoneNo(false);
          phoneNoFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(
            result.message || "Phone No. updated successfully!",
          );
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            phoneNo: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const gmailFormik = useFormik({
    initialValues: {
      iv_gmail: "",
      iv_gmail_remarks: "",
    },
    validationSchema: Yup.object({
      iv_gmail: Yup.string()
  .email("Invalid email format")
  .required("Email is required"),
      iv_gmail_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          email: values.iv_gmail,
          remarks: values.iv_gmail_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeEmailofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          syncAuthIfEditingSelf(selectedUser.userId, updateEmail(values.iv_gmail));
          setOpenProfileModalEmail(false);
          gmailFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "Email updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            email: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const cnicFormik = useFormik({
    initialValues: {
      iv_cnic: "",
      iv_cnic_remarks: "",
    },
    validationSchema: Yup.object({
      iv_cnic: Yup.string()
        .min(13, "Please enter 13 digit CNIC.")
        .max(13, "Please enter 13 digit CNIC.")
        .required("Please enter valid CNIC number.")
        .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
      iv_cnic_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          CNIC: values.iv_cnic,
          remarks: values.iv_cnic_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeCNICofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          syncAuthIfEditingSelf(selectedUser.userId, updateCnic(values.iv_cnic));
          setOpenProfileModalCNIC(false);
          cnicFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "CNIC. updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            CNIC: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  // const handleNextPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(nextPage());
  // };

  // const handlePreviousPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(previousPage());
  // };

  // const handleFirstPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(firstPage());
  // };

  // const handleLastPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(lastPage(totalPages)); // Replace '2' with actual value
  // };

  const handleNextPage = () => {
    setViewBackdrop(true);
    dispatch(nextPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode: usersListOfficeCode,
        pageNumber: pageNumber + 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handlePreviousPage = () => {
    setViewBackdrop(true);
    dispatch(previousPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode: usersListOfficeCode,
        pageNumber: pageNumber - 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handleFirstPage = () => {
    setViewBackdrop(true);
    dispatch(firstPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode: usersListOfficeCode,
        pageNumber: 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handleLastPage = () => {
    setViewBackdrop(true);
    dispatch(lastPage(totalPages));

    dispatch(
      fetchPaginatedUsers({
        officeCode: usersListOfficeCode,
        pageNumber: totalPages,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  // useEffect(() => {
  //     dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: pageNumber, pageSize: pageSize }))
  // }, [pageNumber, pageSize])

  useEffect(() => {
    if (isAdminUser && selectedAdminCompanyCode) {
      setSelectedCompanyCode(String(selectedAdminCompanyCode));
    }
  }, [isAdminUser, selectedAdminCompanyCode]);

  const filterNCApp = (userId) => {
    if (users) {
      let itemFound = users.find((item) => item.userId === userId);
      return itemFound;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setopen2(false);
  };

  const onDelete = async () => {
    var formdata = new FormData();
    formdata.append("toBeDeletedUserId", dltuser);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/deleteUser",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch(() => {});
    handleClose2();
  };

  const convertDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const convertdatetime = (datetimestring) => {
    if (datetimestring) {
      const converted = moment(datetimestring).format("llll");
      return converted;
    }
  };

  const callChangeStatusApi = async (user) => {

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      status: user.status === true ? 0 : 1,
      userId: user.userId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/markActiveInactiveUser",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch(() => {});
  };

  const callResetLoginAttemptsApi = async (params) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      userId: params.userId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "customerFaciliationPortal/resetLoginAttempts",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch(() => {});
  };

  const CustomButton = styled(Button)({
    boxShadow: "none",
    textTransform: "none",
    fontSize: 13,
    padding: "6px 5px",
    border: "1px solid",
    color: "white",
    width: "2px",
    lineHeight: 1,
    backgroundColor: "#2e7d32",
    borderColor: "#2e7d32",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#1b5e20",
      borderColor: "#1b5e20",
      color: "white",
      boxShadow: "none",
    },
  });

  const tblColumns = [
    // { field: "id", headerName: 'ID', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "completename",
      headerName: "Full Name",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "userId",
      headerName: "Username",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "code",
      headerName: "Office Code",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // { field: "roleType", headerName: 'roleType', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "roles",
      headerName: "Roles",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // { field: "created by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    // { field: "created at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "last login attempt at",
      headerName: "Last Login Attempt at",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "loginattempts",
      headerName: "Login Attempts",
      align: "center",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {params.loginattempts > 2 ? (
              <LockResetIcon
                onClick={() => callResetLoginAttemptsApi(params)}
                sx={{ color: "#be032d" }}
              />
            ) : (
              <Person4OutlinedIcon sx={{ color: "#4caf50" }} />
            )}
          </div>
        );
      },
    },
    {
      field: "button",
      headerName: "Inactive | Active",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <ToggleButton
              accountStatus={params.status}
              onChange={() => callChangeStatusApi(params)}
            />
          </div>
        );
      },
    },
    {
      field: "button",
      headerName: "Change Password ",
      align: "center",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <IconButton
              aria-label="delete"
              size="small"
              sx={{ margin: 0.4, padding: 0 }}
            >
              <PasswordRoundedIcon
                sx={{ color: "#e25316ff" }}
                onClick={() => {
                  setSelectedUserId(params.userId);
                  setShowChangePasswordPopup(true);
                }}
                alt="Change Password"
                style={{ width: "24px", height: "24px" }}
              />
            </IconButton>
          </div>
        );
      },
    },
    {
      headerName: "Action",
      sortable: false,
      align: "center",
      field: "buttons",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        const open = Boolean(anchorEl);
        const onViewUser = async (e) => {
          e.stopPropagation();

          const item = filterNCApp(params.userId);
          setDialogRowData(item);

          const selectedUserCompany = item.companyCode;
          // Open profile dialog immediately; load dependent lookup data in background.
          setOpen(true);

          try {
            if (officeCode === "10" && selectedUserCompany) {
              setViewBackdrop(true);

              const formdataSubDivisions = new FormData();
              formdataSubDivisions.append("companyCode", selectedUserCompany);

              const myHeaders = new Headers();
              myHeaders.append("Authorization", token);

              const requestOptionsSubDivisions = {
                method: "POST",
                body: formdataSubDivisions,
                headers: myHeaders,
                redirect: "follow",
              };

              const response = await fetch(
                cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
                requestOptionsSubDivisions,
              );

              const result = await response.json();

              if (result.status === "200") {
                setSubDivisions(result.message);
              }
            }
          } catch (error) {
          } finally {
            setViewBackdrop(false);
          }

        };

        const onDeleteUser = (e) => {
          e.stopPropagation();
          setopen2(true);
          setdltuser(params.userId);
        };
        const onEditUser = (e) => {
          e.stopPropagation();
          const userToEdit = filterNCApp(params.userId);
          Navigate("/user-management/update-user", { state: { userToEdit } });
        };
        const onSessionKill = (e) => {
          e.stopPropagation();
        };

        const handleMenuOpen = (e) => {
          e.stopPropagation();
          const userToEdit = filterNCApp(params.userId);

          setSelectedUser(userToEdit);
          setAnchorEl(e.currentTarget);
        };

        const handleMenuClose = () => {
          setAnchorEl(null);
        };

        const handleChangeProfileName = () => {
          handleMenuClose();
          nameFormik.values.iv_full_name = selectedUser.name;
          setOpenProfileModalName(true);
        };
        const handleChangeProfilePhoneNo = () => {
          handleMenuClose();
          phoneNoFormik.values.iv_phone_no = selectedUser.phoneNo;
          setOpenProfileModalPhoneNo(true);
        };

        const handleChangeProfileEmail = () => {
          handleMenuClose();
          gmailFormik.values.iv_gmail = selectedUser.email;
          setOpenProfileModalEmail(true);
        };

        const handleChangeProfileCNIC = () => {
          handleMenuClose();
          cnicFormik.values.iv_cnic = selectedUser.CNIC;
          setOpenProfileModalCNIC(true);
        };

        const handleChangeTransferPosting = () => {
          setOpenTransferPopup(true);
        };

        const handleChangeRole = () => {
          handleMenuClose();
        };
        return (
          <>
            <Box>
              {/* <IconButton onClick={onSessionKill} aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }}>
                                <ClearIcon fontSize="inherit" sx={{ color: 'orange' }} />
                            </IconButton> */}
              {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Read",
              ) ? (
                <IconButton
                  onClick={onViewUser}
                  aria-label="delete"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <VisibilityIcon
                    sx={{ color: "skyblue" }}
                    fontSize="inherit"
                  />
                </IconButton>
              ) : null}

              {/* Previous Edit Option */}

              {/* {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Update",
              ) ? (
                <IconButton
                  onClick={onEditUser}
                  aria-label="delete"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <EditIcon fontSize="inherit" sx={{ color: "blue" }} />
                </IconButton>
              ) : null} */}

              {/* Delete  */}
              {/* {
                                CheckPermissions(permissions, 'Access Management', 'User Management', 'CSD Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'RO Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'CSC Admin Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'CSR Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteUser}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            } */}
              {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Read",
              ) ? (
                <>
                  <IconButton
                    onClick={handleMenuOpen}
                    aria-label="more"
                    size="small"
                    sx={{ margin: 0.4, padding: 0 }}
                  >
                    <EditIcon fontSize="inherit" sx={{ color: "#006ad1" }} />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        border: `1px solid ${colors.white}`,
                        boxShadow: "none",
                      },
                    }}
                    MenuListProps={{
                      sx: {
                        padding: 0,
                      },
                    }}
                  >
                    <MenuItem
                      disableRipple
                      sx={{
                        justifyContent: "start",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: colors.white,
                        backgroundColor: colors.primaryBlue,
                        pointerEvents: "none",
                        "&:hover": {
                          backgroundColor: colors.primaryBlue,
                          color: colors.white,
                        },
                      }}
                    >
                      Edit Profile{" "}
                      {selectedUser ? `(${selectedUser.userId})` : ""} <br />
                    </MenuItem>

                    <MenuItem
                      onClick={handleChangeProfileName}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <DriveFileRenameOutlineIcon
                          fontSize="small"
                          sx={{ color: "#eb7b30ff" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Name" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfilePhoneNo}
                    >
                      <ListItemIcon>
                        <LocalPhoneIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Phone No" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfileEmail}
                    >
                      <ListItemIcon>
                        <EmailIcon
                          fontSize="small"
                          sx={{ color: "#d46759ff" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Email" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfileCNIC}
                    >
                      <ListItemIcon>
                        <ContactEmergencyIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change CNIC" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeTransferPosting}
                    >
                      <ListItemIcon>
                        <TransferWithinAStationIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Transfer Posting" />
                    </MenuItem>
                  </Menu>
                </>
              ) : null}
            </Box>
          </>
        );
      },
    },
  ];

  const apiToDataGridConversion = () => {
    const myArray = users;
    const tempArray = [];
    if (myArray) {
      //for(let i = 0; i <= myArray.length; i++){
      myArray.forEach((item) => {
        const dataGridObject = {
          // "id": item.id,
          completename: item.name,
          userId: item.userId,
          code: item.code,
          // "roleType": item.roleTypeId == "1" ? "Commercial" : item.roleTypeId == "2" ? "Technical" : '',
          roles: item.roleName,
          "created by": item.created_by,
          "created at": convertDate(item.created_at),
          "last login attempt at": item.lastLoginAttemptTime
            ? item.lastLoginAttemptTime
            : "-",
          status: item.status == "1" ? true : false,
          loginattempts: item.loginAttempts,
        };
        tempArray.push(dataGridObject);
      });
    } else {
      const dataGridObject = {
        // "id": ' ',
        connectionType: "",
        applicantName: " ",
        applicantCNIC: " ",
        applicationStatusId: statusFunc(" "),
      };
      tempArray.push(dataGridObject);
    }
    setNewUsersToDataGrid(tempArray);
    setViewBackdrop(false);
  };

  const statusFunc = (x) => {
    if (x === 0) {
      return "Pending";
    } else if (x === 1) {
      return "In Process";
    } else if (x === 2) {
      return "Approved";
    }
  };

  const getCompanyName = (code) => {
    let companyObject = subDivisions.find((item) => item.companyCode === code);
    if (companyObject) {
      return companyObject.companyName;
    }
  };
  const getCircleName = (code) => {
    let circleObject = subDivisions.find((item) => item.circleCode === code);
    if (circleObject) {
      return circleObject.circleName;
    }
  };
  const getDivisionName = (code) => {
    let divisionObject = subDivisions.find(
      (item) => item.divisionCode === code,
    );
    if (divisionObject) {
      return divisionObject.divisionName;
    }
  };
  const getSubDivisionName = (code) => {
    let subDivisionObject = subDivisions.find(
      (item) => item.subDivisionCode === code,
    );
    if (subDivisionObject) {
      return subDivisionObject.subDivisionName;
    }
  };
  const getSupportCenterName = async (code) => {
    if (!code) return "-";

    const prefix = String(code).slice(0, 2);
    const allSupportCenters = await AllCFCs(token, permissions, prefix);

    if (!allSupportCenters || !Array.isArray(allSupportCenters)) {
      return "N/A";
    }

    const supportCenter = allSupportCenters.find(
      (item) => Number(item.cfcId) === Number(code),
    );

    if (!supportCenter) {
      return "Not Found";
    }

    // Try multiple possible field names
    const name =
      supportCenter.cfcName ||
      supportCenter.name ||
      supportCenter.centerName ||
      supportCenter.description ||
      "Unnamed CFC";

    return name;
  };

  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
  //     initialValues: {
  //         iv_search_user: '',
  //     },
  //     validationSchema: Yup.object().shape({
  //         iv_search_user: Yup.string().min(3, 'Search term must be max atleast 3 characters.').max(20, 'Search term can be max 20 characters.').required('User ID is required.'),
  //     }),
  //     onSubmit: (values) => {
  //         dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: pageNumber, pageSize: pageSize, searchParameter: values.iv_search_user }))
  //     }
  // });

  // useEffect(() => {
  //     if (!values.iv_search_user) {
  //         dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: 1, pageSize: 20 }))
  //     }
  // }, [values.iv_search_user])
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      iv_search_user: "",
    },
    validationSchema: Yup.object().shape({
      iv_search_user: Yup.string()
        .min(3, "Search term must be at least 3 characters.")
        .max(20, "Search term can be max 20 characters.")
        .required("User id is required."),
    }),
    onSubmit: (values) => {
    },
  });

  const handleChangeCompany = (company) => {
    setSelectedCompanyCode(company);
    dispatch(firstPage());
  };

  useEffect(() => {
    dispatch(
      fetchPaginatedUsers({
        officeCode: usersListOfficeCode,
        pageNumber,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  }, [pageNumber, pageSize, usersListOfficeCode]);

  // const handleInputChange = (e) => {
  //     const { value } = e.target;
  //     setSearchTerm(value);

  //     if (typingTimeout) {
  //         clearTimeout(typingTimeout);
  //     }

  //     const timeout = setTimeout(() => {
  //         dispatch(fetchPaginatedUsers({
  //             officeCode,
  //             pageNumber,
  //             pageSize,
  //             searchParameter: value
  //         }))
  //             .unwrap()
  //             .then((response) => {
  //                 if (response?.status === 'Data Not Found.') {
  //                     setNoDataFound(true);
  //                 } else {
  //                     setNoDataFound(false);
  //                 }
  //             })
  //             .catch((error) => {
  //                 setNoDataFound(true);
  //             });
  //     }, 500);

  //     setTypingTimeout(timeout);
  // };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // 👇 Reset to page 1 before making search API call
    dispatch(firstPage());

    const timeout = setTimeout(() => {
      dispatch(
        fetchPaginatedUsers({
          officeCode: usersListOfficeCode,
          pageNumber: 1, // ⬅️ Force page 1 for all search inputs
          pageSize,
          searchParameter: value,
        }),
      )
        .unwrap()
        .then((response) => {
          if (response?.status === "Data Not Found.") {
            setNoDataFound(true);
          } else {
            setNoDataFound(false);
          }
        })
        .catch((error) => {
          setNoDataFound(true);
        });
    }, 500);

    setTypingTimeout(timeout);
  };

  useEffect(() => {
    if (!values.iv_search_user) {
      setNoDataFound(false);
      dispatch(
        fetchPaginatedUsers({
          officeCode: usersListOfficeCode,
          pageNumber: 1,
          pageSize: 20,
        }),
      );
    }
  }, [values.iv_search_user]);

  useEffect(() => {
    const loadCfcName = async () => {
      if (!open || !dialogRowData?.cscId) {
        setSupportCenterName("-");
        return;
      }

      setIsLoadingCfcName(true);
      try {
        const name = await getSupportCenterName(dialogRowData.cscId);
        setSupportCenterName(name);
      } catch (err) {
        setSupportCenterName("Error");
      } finally {
        setIsLoadingCfcName(false);
      }
    };

    loadCfcName();
  }, [open, dialogRowData?.cscId]);

  const userProfileDetailFields = useMemo(() => {
    const d = dialogRowData;
    if (!d || Object.keys(d).length === 0) return [];
    return [
      { label: "Username", value: d.userId || "-" },
      { label: "Name", value: d.name || "-" },
      { label: "Email", value: d.email || "-" },
      { label: "Phone No", value: d.phoneNo || "-" },
      { label: "CNIC", value: d.CNIC || "-" },
      { label: "Role", value: d.roleName || "-" },
      {
        label: "Status",
        value:
          d.status === true
            ? "Active"
            : d.status === false
              ? "Inactive"
              : "-",
      },
      { label: "Created By", value: d.created_by || "-" },
      {
        label: "Created At",
        value: convertdatetime(d.created_at) || "-",
      },
      { label: "Last Updated By", value: d.updated_by || "-" },
      {
        label: "Last Updated At",
        value: convertdatetime(d.updated_at) || "-",
      },
      {
        label: "Company",
        value: getCompanyName(d.companyCode) || "PITC",
      },
      ...(d.hierarchy >= 3
        ? [
            {
              label: "Circle",
              value: getCircleName(d.circleCode) || "-",
            },
          ]
        : []),
      ...(d.hierarchy === 4 ||
      d.hierarchy === 51 ||
      d.hierarchy === 52 ||
      d.hierarchy === 5
        ? [
            {
              label: "Division",
              value: getDivisionName(d.divisionCode) || "-",
            },
          ]
        : []),
      ...(d.hierarchy === 52 || d.hierarchy === 5
        ? [
            {
              label: "Sub Division",
              value: getSubDivisionName(d.subDivisionCode) || "-",
            },
          ]
        : []),
      ...(d?.cscId && d?.roleTypeId === 1
        ? [
            {
              label: "Customer Support Center",
              value: isLoadingCfcName ? "Loading..." : supportCenterName,
            },
          ]
        : []),
    ];
  }, [dialogRowData, supportCenterName, isLoadingCfcName]);

  useEffect(() => {
    let mounted = true;
    let timeoutId;
    let objectUrl = null;

    // Show fallback immediately; replace only when image is proven loadable.
    setProfileImageSrc(UserIconImage);

    const profilePicture = dialogRowData?.profilePicture;
    if (!profilePicture) return undefined;

    let candidate = null;
    if (typeof profilePicture !== "string") {
      objectUrl = URL.createObjectURL(profilePicture);
      candidate = objectUrl;
    } else {
      const picture = profilePicture.trim();
      if (
        picture &&
        (picture.startsWith("data:image") ||
          picture.startsWith("blob:") ||
          picture.startsWith("http://") ||
          picture.startsWith("https://"))
      ) {
        candidate = picture;
      }
    }

    if (!candidate) {
      return () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      };
    }

    const probeImage = new Image();
    const cleanup = () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };

    timeoutId = setTimeout(() => {
      if (mounted) setProfileImageSrc(UserIconImage);
    }, 1200);

    probeImage.onload = () => {
      if (!mounted) return;
      clearTimeout(timeoutId);
      setProfileImageSrc(candidate);
    };

    probeImage.onerror = () => {
      if (!mounted) return;
      clearTimeout(timeoutId);
      setProfileImageSrc(UserIconImage);
    };

    probeImage.src = candidate;

    return () => {
      mounted = false;
      cleanup();
    };
  }, [dialogRowData?.profilePicture]);

  return (
    <>
      <Box className="form-box user-management-list">
        <Box className="mgmt-page-header">
          <div className="mgmt-page-header__leading">
            <h3 className="page-title">User Management</h3>
            {isAdminUser && (
              <AdminCompanySelect
                value={selectedCompanyCode}
                onChange={handleChangeCompany}
                minWidth={180}
                restrictToEnabled={false}
              />
            )}
          </div>

          <div className="mgmt-table-search">
            <span className="mgmt-table-search__badge" aria-hidden="true">
              <SearchIcon className="mgmt-table-search__icon" />
            </span>
            <input
              type="text"
              className="mgmt-table-search__input"
              value={values.iv_search_user}
              name="iv_search_user"
              onChange={(e) => {
                handleChange(e);
                handleInputChange(e);
              }}
              onBlur={handleBlur}
              placeholder="Search by Username, Role, Complete Name..."
              maxLength={20}
              aria-label="Search users"
            />
          </div>
        </Box>

        {errors.iv_search_user && touched.iv_search_user && (
          <Box
            className="form-error user-mgmt-search-error"
            sx={{
              color: "red",
              fontSize: "12px",
              marginTop: "-8px",
              marginBottom: "12px",
            }}
          >
            {errors.iv_search_user}
          </Box>
        )}

        <Box className="application-table">
            <BasicTable
              data={noDataFound ? [] : newusersToDataGrid}
              columns={tblColumns}
              sx={tableStyle}
              rowHeight={37.5}
              pageSize={20}
              totalPages={noDataFound ? "1" : totalPages}
              totalRecords={totalRecords}
              currentPage={noDataFound ? "1" : currentPage}
              firstPage={handleFirstPage}
              nextPage={handleNextPage}
              previousPage={handlePreviousPage}
              lastPage={handleLastPage}
              handleRowClick={() => {}}
              rowsPerPageOptions={[18, 30, 60]}
              rowsPageOption={false}
              isLoading={isLoad}
              getRowStyle={(params) => {
                return params.indexRelativeToCurrentPage % 2 === 0
                  ? tableStyle.evenRow
                  : tableStyle.oddRow;
              }}
            />
        </Box>
      </Box>

      {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { width: '85%',  maxWidth: 800,borderRadius: 3 } }} // increased width
            >
                <DialogTitle id="alert-dialog-title" sx={{ position: 'relative' }}>
                    <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        User Details
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                        <img
                            src={
                                typeof dialogRowData.profilePicture === 'string'
                                    ? dialogRowData.profilePicture
                                    : dialogRowData.profilePicture
                                        ? URL.createObjectURL(dialogRowData.profilePicture)
                                        : UserIconImage
                            }
                            alt="avatar"
                            width={170}
                            height={170}
                            onError={(e) => {
                                e.target.src = UserIconImage;
                            }}
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                    <hr></hr>

                    <Grid container spacing={2}>
                        {[
                            // { label: 'ID', value: dialogRowData.id },
                            { label: 'Name', value: dialogRowData.name },
                            { label: 'Username', value: dialogRowData.userId },
                            { label: 'Email', value: dialogRowData.email },
                            { label: 'Phone No', value: dialogRowData.phoneNo },
                            { label: 'CNIC', value: dialogRowData.CNIC },
                            { label: 'Status', value: 'Active' },
                            { label: 'Role', value: dialogRowData.roleName },
                            // { label: 'Confirmed', value: 'Yes' },
                            { label: 'Created By', value: dialogRowData.created_by },
                            { label: 'Created At', value: convertdatetime(dialogRowData.created_at) },
                            { label: 'Last Updated By', value: dialogRowData.updated_by },
                            { label: 'Last Updated At', value: dialogRowData.updated_at },
                            { label: 'Company', value: getCompanyName(dialogRowData.companyCode) || 'PITC' },
                            ...(dialogRowData.hierarchy >= 3
                                ? [{ label: 'Circle', value: getCircleName(dialogRowData.circleCode) }]
                                : []),
                            ...(dialogRowData.hierarchy >= 4
                                ? [{ label: 'Division', value: getDivisionName(dialogRowData.divisionCode) }]
                                : []),
                            ...(dialogRowData.hierarchy === 51
                                ? [{ label: 'Support Center', value: getSupportCenterName(dialogRowData.cscId) }]
                                : []),
                            ...(dialogRowData.hierarchy === 52
                                ? [{ label: 'Sub Division', value: getSubDivisionName(dialogRowData.subDivisionCode) }]
                                : []),
                        ].map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={6} key={index}>
                                <label style={{ fontWeight: 600 }}>{item.label}</label>
                                <TextField
                                    value={item.value}
                                    fullWidth
                                    disabled
                                    sx={{
                                        mt: 0.5,
                                        '.MuiInputBase-input': { height: '1.2rem' },
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>

                </DialogContent>
            </Dialog> */}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        aria-labelledby="user-details-profile-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 720,
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-details-profile-dialog-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            User Profile
          </Typography>
          <IconButton
            onClick={handleClose}
            size="small"
            aria-label="Close user profile"
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            bgcolor: "#f0f4f9",
            overflowY: "visible",
            overflowX: "hidden",
            maxHeight: "none",
            minHeight: 0,
          }}
        >
          <Box sx={{ px: { xs: 1.5, sm: 2 }, pt: 1.25, pb: 1.5 }}>
            <form>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 1.25,
                }}
              >
                <Box
                  component="img"
                  src={profileImageSrc}
                  alt="Profile"
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = UserIconImage;
                  }}
                  sx={{
                    width: 128,
                    height: 128,
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: "4px solid #fff",
                    boxShadow:
                      "0 0 0 3px #006ad1, 0 8px 22px rgba(0, 106, 209, 0.25)",
                    flexShrink: 0,
                  }}
                />
              </Box>

              <Box
                sx={{
                  bgcolor: "common.white",
                  borderRadius: 2,
                  p: { xs: 1.25, sm: 1.5 },
                  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#006ad1",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    fontSize: "0.72rem",
                  }}
                >
                  User information
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Grid container spacing={1}>
                  {(() => {
                    const nameField = userProfileDetailFields.find(
                      (f) => f.label === "Name",
                    );
                    const restFields = userProfileDetailFields.filter(
                      (f) => f.label !== "Name",
                    );
                    return (
                      <>
                        {nameField ? (
                          <Grid item xs={12} key="profile-name">
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                            >
                              {nameField.label}
                            </Typography>
                            <TextField
                              value={nameField.value}
                              fullWidth
                              disabled
                              size="small"
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: 1.5,
                                  bgcolor: "grey.50",
                                  minHeight: 36,
                                  py: 0,
                                },
                                "& .MuiOutlinedInput-input": {
                                  py: 0.65,
                                },
                              }}
                            />
                          </Grid>
                        ) : null}
                        {restFields.map((item, index) => (
                          <Grid item xs={12} sm={6} key={`${item.label}-${index}`}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ fontWeight: 600, display: "block", mb: 0.35 }}
                            >
                              {item.label}
                            </Typography>
                            <TextField
                              value={item.value}
                              fullWidth
                              disabled
                              size="small"
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: 1.5,
                                  bgcolor: "grey.50",
                                  minHeight: 36,
                                  py: 0,
                                },
                                "& .MuiOutlinedInput-input": {
                                  py: 0.65,
                                },
                              }}
                            />
                          </Grid>
                        ))}
                      </>
                    );
                  })()}
                </Grid>
              </Box>
            </form>
          </Box>
        </DialogContent>
        <DialogActions sx={{ bgcolor: "#f0f4f9", py: 0.5, minHeight: 0 }} />
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" Are you sure to delete this record"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose2}>Cancel</Button>
          <Button onClick={onDelete} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showChangePasswordPopup}
        onClose={handleCloseChangePasswordDialog}
        fullWidth
        maxWidth="xs"
        aria-labelledby="user-mgmt-change-password-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 440,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-mgmt-change-password-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            Change Password
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={handleCloseChangePasswordDialog}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form
              noValidate
              className="complaintform"
              style={{ marginTop: 0 }}
              onSubmit={passwordChangeFormik.handleSubmit}
            >
              <Grid container spacing={2.5}>
                <Grid item xs={12} marginTop={2}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    New Password
                  </Typography>
                  <TextField
                    type={showNewPassword ? "text" : "password"}
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={passwordChangeFormik.handleChange}
                    name="iv_new_password"
                    value={passwordChangeFormik.values.iv_new_password}
                    onBlur={passwordChangeFormik.handleBlur}
                    error={Boolean(
                      passwordChangeFormik.errors.iv_new_password &&
                        (passwordChangeFormik.touched.iv_new_password ||
                          passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_new_password &&
                      (passwordChangeFormik.touched.iv_new_password ||
                        passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_new_password
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            onClick={handleClickShowNewPassword}
                            edge="end"
                            size="small"
                            aria-label="toggle new password visibility"
                          >
                            {!showNewPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Confirm New Password
                  </Typography>
                  <TextField
                    type={showConfirmPassword ? "text" : "password"}
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={passwordChangeFormik.handleChange}
                    name="iv_confirm_password"
                    value={passwordChangeFormik.values.iv_confirm_password}
                    onBlur={passwordChangeFormik.handleBlur}
                    error={Boolean(
                      passwordChangeFormik.errors.iv_confirm_password &&
                        (passwordChangeFormik.touched.iv_confirm_password ||
                          passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_confirm_password &&
                      (passwordChangeFormik.touched.iv_confirm_password ||
                        passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_confirm_password
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                            size="small"
                            aria-label="toggle confirm password visibility"
                          >
                            {!showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Remarks
                  </Typography>
                  <TextField
                    type="text"
                    autoComplete="off"
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={2}
                    name="iv_remarks"
                    value={passwordChangeFormik.values.iv_remarks}
                    onChange={passwordChangeFormik.handleChange}
                    onBlur={passwordChangeFormik.handleBlur}
                    id="iv_remarks"
                    error={Boolean(
                      passwordChangeFormik.errors.iv_remarks &&
                        (passwordChangeFormik.touched.iv_remarks ||
                          passwordChangeFormik.submitCount > 0),
                    )}
                    helperText={
                      passwordChangeFormik.errors.iv_remarks &&
                      (passwordChangeFormik.touched.iv_remarks ||
                        passwordChangeFormik.submitCount > 0)
                        ? passwordChangeFormik.errors.iv_remarks
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={USER_MGMT_MODAL_PRIMARY_BUTTON_SX}
                  >
                    SUBMIT
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalName}
        onClose={handleCloseName}
        fullWidth
        maxWidth="sm"
        aria-labelledby="user-mgmt-edit-name-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 480,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-mgmt-edit-name-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            Edit Name
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={handleCloseName}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form noValidate onSubmit={nameFormik.handleSubmit}>
              <Grid container spacing={2.5}>
                <Grid item xs={12} marginTop={2}>
                  <Typography
                    variant="body2"
                    sx={{mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Full Name
                  </Typography>
                  <TextField
                    type="text"
                    disabled={!editableFields.name}
                    onChange={nameFormik.handleChange}
                    onBlur={nameFormik.handleBlur}
                    name="iv_full_name"
                    value={nameFormik.values.iv_full_name}
                    fullWidth
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    error={Boolean(
                      nameFormik.errors.iv_full_name &&
                        (nameFormik.touched.iv_full_name ||
                          nameFormik.submitCount > 0),
                    )}
                    helperText={
                      nameFormik.errors.iv_full_name &&
                      (nameFormik.touched.iv_full_name ||
                        nameFormik.submitCount > 0)
                        ? nameFormik.errors.iv_full_name
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!editableFields.name && (
                            <IconButton
                              type="button"
                              onClick={() => toggleEdit("name")}
                              edge="end"
                              size="small"
                              aria-label="Edit full name"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Remarks
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={2}
                    autoComplete="off"
                    name="iv_full_name_remarks"
                    value={nameFormik.values.iv_full_name_remarks}
                    onChange={nameFormik.handleChange}
                    onBlur={nameFormik.handleBlur}
                    id="iv_full_name_remarks"
                    error={Boolean(
                      nameFormik.errors.iv_full_name_remarks &&
                        (nameFormik.touched.iv_full_name_remarks ||
                          nameFormik.submitCount > 0),
                    )}
                    helperText={
                      nameFormik.errors.iv_full_name_remarks &&
                      (nameFormik.touched.iv_full_name_remarks ||
                        nameFormik.submitCount > 0)
                        ? nameFormik.errors.iv_full_name_remarks
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={
                      nameFormik.values.iv_full_name === selectedUser?.name
                    }
                    sx={USER_MGMT_MODAL_PRIMARY_BUTTON_SX}
                  >
                    SAVE
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalPhoneNo}
        onClose={handleClosePhoneNo}
        fullWidth
        maxWidth="sm"
        aria-labelledby="user-mgmt-edit-phone-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 480,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-mgmt-edit-phone-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            Edit Phone No
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={handleClosePhoneNo}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form noValidate onSubmit={phoneNoFormik.handleSubmit}>
              <Grid container spacing={2.5}>
                <Grid item xs={12} marginTop={2}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Phone No
                  </Typography>
                  <TextField
                    type="text"
                    disabled={!editableFields.phoneNo}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      phoneNoFormik.setFieldValue("iv_phone_no", value);
                    }}
                    onBlur={phoneNoFormik.handleBlur}
                    name="iv_phone_no"
                    value={phoneNoFormik.values.iv_phone_no}
                    inputProps={{ maxLength: 11 }}
                    fullWidth
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    error={Boolean(
                      phoneNoFormik.errors.iv_phone_no &&
                        (phoneNoFormik.touched.iv_phone_no ||
                          phoneNoFormik.submitCount > 0),
                    )}
                    helperText={
                      phoneNoFormik.errors.iv_phone_no &&
                      (phoneNoFormik.touched.iv_phone_no ||
                        phoneNoFormik.submitCount > 0)
                        ? phoneNoFormik.errors.iv_phone_no
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!editableFields.phoneNo && (
                            <IconButton
                              type="button"
                              onClick={() => toggleEdit("phoneNo")}
                              edge="end"
                              size="small"
                              aria-label="Edit phone number"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Remarks
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={2}
                    autoComplete="off"
                    name="iv_phone_no_remarks"
                    value={phoneNoFormik.values.iv_phone_no_remarks}
                    onChange={phoneNoFormik.handleChange}
                    onBlur={phoneNoFormik.handleBlur}
                    id="iv_phone_no_remarks"
                    error={Boolean(
                      phoneNoFormik.errors.iv_phone_no_remarks &&
                        (phoneNoFormik.touched.iv_phone_no_remarks ||
                          phoneNoFormik.submitCount > 0),
                    )}
                    helperText={
                      phoneNoFormik.errors.iv_phone_no_remarks &&
                      (phoneNoFormik.touched.iv_phone_no_remarks ||
                        phoneNoFormik.submitCount > 0)
                        ? phoneNoFormik.errors.iv_phone_no_remarks
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={
                      phoneNoFormik.values.iv_phone_no === selectedUser?.phoneNo
                    }
                    sx={USER_MGMT_MODAL_PRIMARY_BUTTON_SX}
                  >
                    SAVE
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalEmail}
        onClose={handleCloseEmail}
        fullWidth
        maxWidth="sm"
        aria-labelledby="user-mgmt-edit-email-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 480,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-mgmt-edit-email-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            Edit Email
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={handleCloseEmail}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form noValidate onSubmit={gmailFormik.handleSubmit}>
              <Grid container spacing={2.5}>
                <Grid item xs={12} marginTop={2}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Email
                  </Typography>
                  <TextField
                    type="text"
                    disabled={!editableFields.email}
                    onChange={gmailFormik.handleChange}
                    onBlur={gmailFormik.handleBlur}
                    name="iv_gmail"
                    value={gmailFormik.values.iv_gmail}
                    fullWidth
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    error={Boolean(
                      gmailFormik.errors.iv_gmail &&
                        (gmailFormik.touched.iv_gmail ||
                          gmailFormik.submitCount > 0),
                    )}
                    helperText={
                      gmailFormik.errors.iv_gmail &&
                      (gmailFormik.touched.iv_gmail ||
                        gmailFormik.submitCount > 0)
                        ? gmailFormik.errors.iv_gmail
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!editableFields.email && (
                            <IconButton
                              type="button"
                              onClick={() => toggleEdit("email")}
                              edge="end"
                              size="small"
                              aria-label="Edit email"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Remarks
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={2}
                    autoComplete="off"
                    name="iv_gmail_remarks"
                    value={gmailFormik.values.iv_gmail_remarks}
                    onChange={gmailFormik.handleChange}
                    onBlur={gmailFormik.handleBlur}
                    id="iv_gmail_remarks"
                    error={Boolean(
                      gmailFormik.errors.iv_gmail_remarks &&
                        (gmailFormik.touched.iv_gmail_remarks ||
                          gmailFormik.submitCount > 0),
                    )}
                    helperText={
                      gmailFormik.errors.iv_gmail_remarks &&
                      (gmailFormik.touched.iv_gmail_remarks ||
                        gmailFormik.submitCount > 0)
                        ? gmailFormik.errors.iv_gmail_remarks
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={gmailFormik.values.iv_gmail === selectedUser?.email}
                    sx={USER_MGMT_MODAL_PRIMARY_BUTTON_SX}
                  >
                    SAVE
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalCNIC}
        onClose={handleCloseCNIC}
        fullWidth
        maxWidth="sm"
        aria-labelledby="user-mgmt-edit-cnic-title"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            maxWidth: 480,
            width: "100%",
            boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
          },
        }}
      >
        <DialogTitle
          id="user-mgmt-edit-cnic-title"
          component="div"
          className="user-mgmt-modal-header"
          sx={USER_MGMT_PROFILE_MODAL_HEADER_SX}
        >
          <Typography variant="h6" sx={USER_MGMT_PROFILE_MODAL_TITLE_SX}>
            Edit CNIC
          </Typography>
          <IconButton
            id="clearPopup"
            size="small"
            aria-label="Close"
            onClick={handleCloseCNIC}
            sx={{
              color: "common.white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: "#ffffff",
            pt: 8,
            pb: 2.5,
            px: 2.5,
          }}
        >
          <DialogContentText component="div" sx={{ m: 0 }}>
            <form noValidate onSubmit={cnicFormik.handleSubmit}>
              <Grid container spacing={2.5}>
                <Grid item xs={12} marginTop={2}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    CNIC
                  </Typography>
                  <TextField
                    type="text"
                    disabled={!editableFields.CNIC}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      cnicFormik.setFieldValue("iv_cnic", value);
                    }}
                    onBlur={cnicFormik.handleBlur}
                    name="iv_cnic"
                    value={cnicFormik.values.iv_cnic}
                    fullWidth
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{ maxLength: 13 }}
                    error={Boolean(
                      cnicFormik.errors.iv_cnic &&
                        (cnicFormik.touched.iv_cnic ||
                          cnicFormik.submitCount > 0),
                    )}
                    helperText={
                      cnicFormik.errors.iv_cnic &&
                      (cnicFormik.touched.iv_cnic ||
                        cnicFormik.submitCount > 0)
                        ? cnicFormik.errors.iv_cnic
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!editableFields.CNIC && (
                            <IconButton
                              type="button"
                              onClick={() => toggleEdit("CNIC")}
                              edge="end"
                              size="small"
                              aria-label="Edit CNIC"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 0.75, fontWeight: 600, color: "text.secondary" }}
                  >
                    Remarks
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={2}
                    autoComplete="off"
                    name="iv_cnic_remarks"
                    value={cnicFormik.values.iv_cnic_remarks}
                    onChange={cnicFormik.handleChange}
                    onBlur={cnicFormik.handleBlur}
                    id="iv_cnic_remarks"
                    error={Boolean(
                      cnicFormik.errors.iv_cnic_remarks &&
                        (cnicFormik.touched.iv_cnic_remarks ||
                          cnicFormik.submitCount > 0),
                    )}
                    helperText={
                      cnicFormik.errors.iv_cnic_remarks &&
                      (cnicFormik.touched.iv_cnic_remarks ||
                        cnicFormik.submitCount > 0)
                        ? cnicFormik.errors.iv_cnic_remarks
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        bgcolor: "#fafafa",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {apiError && (
                    <Error
                      error={apiError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 0.5 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={cnicFormik.values.iv_cnic === selectedUser?.CNIC}
                    sx={USER_MGMT_MODAL_PRIMARY_BUTTON_SX}
                  >
                    SAVE
                  </Button>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Modal
        open={openTransferSuccessModal}
        onClose={() => {
          setOpenTransferSuccessModal(false);
          setTransferSuccessMessage("");
          // Optional: refresh table after success
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          window.location.reload();
        }}
        aria-labelledby="success-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: "2.5rem",
              color: "#2e7d32",
            }}
          />
          <Typography
            id="success-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Success!
          </Typography>
          <Typography color="text.secondary">
            {transferSuccessMessage || "Transfer posted successfully."}
          </Typography>
        </Box>
      </Modal>
      <UpdateUserPopup
        open={openTransferPopup}
        onClose={() => {
          setOpenTransferPopup(false);
          setSelectedUser(null);
          setAnchorEl(null);
        }}
        userToEdit={selectedUser}
        onTransferSuccess={(message) => {
          setTransferSuccessMessage(message);
          setOpenTransferSuccessModal(true);
        }}
        // onUpdated can stay if you still use it for other cases
        onUpdated={() => {
          dispatch(
            fetchPaginatedUsers({
              officeCode: usersListOfficeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
        }}
      />

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        aria-labelledby="success-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: "2.5rem",
              color: "#2e7d32",
            }}
          />
          <Typography
            id="success-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Success!
          </Typography>

          <Typography color="text.secondary">{successMessage}</Typography>
        </Box>
      </Modal>
      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Password Changed Successfully.
        </Alert>
      </Snackbar>
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
}
